import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, InputNumber, Button } from 'antd';
import { GripVertical, X } from 'lucide-react';
import { Reorder } from 'framer-motion';

const CallPreferenceModalV2 = ({ isOpen, onClose, onSave, settings }) => {
  const [columnOrder, setColumnOrder] = useState([]);
  const [showWidget, setShowWidget] = useState({
    PrioritizeScheduled: true,
    AfterFollowUp: true,
    AfterTask: true,
    AfterAppointment: true,
    ScheduleTime: 0
  });

  useEffect(() => {
    if (isOpen && settings) {
      // Initialize Column Order from leftTabs if not present
      if (settings.ColumnOrder && settings.ColumnOrder.length > 0) {
        setColumnOrder(settings.ColumnOrder);
      } else if (settings.leftTabs) {
        setColumnOrder(settings.leftTabs.map((tab, index) => ({
          name: tab.name,
          text: tab.text,
          order: index
        })));
      }

      // Initialize ShowWidget settings
      if (settings.ShowWidget) {
        setShowWidget({
          ...showWidget,
          ...settings.ShowWidget
        });
      }
    }
  }, [isOpen, settings]);

  const handleSave = () => {
    onSave({
      ColumnOrder: columnOrder.map((item, idx) => ({ ...item, order: idx })),
      ShowWidget: showWidget
    });
  };

  return (
    <Modal
      title={
        <div className="flex items-center justify-between pr-8">
          <span className="text-lg font-bold text-slate-800">Call Setting</span>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="rounded-xl font-bold h-10 px-6 border-slate-200 hover:border-slate-300">
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave} className="rounded-xl font-bold h-10 px-8 bg-blue-600 hover:bg-blue-700 shadow-lg shadow-blue-200 border-none">
          Save
        </Button>
      ]}
      width={600}
      className="premium-modal"
      closeIcon={<X size={20} className="text-slate-400 hover:text-slate-600" />}
      centered
    >
      <div className="space-y-6 py-4">
        <div className="space-y-4">
          <h4 className="text-sm font-bold text-slate-700 leading-snug">
            Choose order the call list as per your preference (the call will be queued for the dialer as pr the following order)
          </h4>
          
          <div className="max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
            <Reorder.Group axis="y" values={columnOrder} onReorder={setColumnOrder} className="space-y-2">
              {columnOrder.map((item) => (
                <Reorder.Item
                  key={item.name}
                  value={item}
                  className="flex items-center gap-3 p-3 bg-white border border-slate-200 rounded-xl group hover:border-blue-300 hover:shadow-md transition-all cursor-grab active:cursor-grabbing active:scale-[1.02] bg-white relative z-10"
                >
                  <div className="text-slate-400 group-hover:text-blue-500">
                    <GripVertical size={18} />
                  </div>
                  <span className="text-sm font-semibold text-slate-700 select-none">{item.text}</span>
                </Reorder.Item>
              ))}
            </Reorder.Group>
          </div>
        </div>

        <div className="space-y-4 pt-4 border-t border-slate-100">
          <Checkbox 
            checked={showWidget.PrioritizeScheduled}
            onChange={(e) => setShowWidget(prev => ({ ...prev, PrioritizeScheduled: e.target.checked }))}
            className="flex items-center text-sm font-bold text-slate-600 hover:text-slate-900"
          >
            Prioritize Scheduled calls at scheduled time
          </Checkbox>

          <Checkbox 
            checked={showWidget.AfterFollowUp}
            onChange={(e) => setShowWidget(prev => ({ ...prev, AfterFollowUp: e.target.checked }))}
            className="flex items-center text-sm font-bold text-slate-600 hover:text-slate-900"
          >
            Showed widget after follow-up was added
          </Checkbox>

          <Checkbox 
            checked={showWidget.AfterTask}
            onChange={(e) => setShowWidget(prev => ({ ...prev, AfterTask: e.target.checked }))}
            className="flex items-center text-sm font-bold text-slate-600 hover:text-slate-900"
          >
            Show Widget After Task Add/Edit
          </Checkbox>

          <Checkbox 
            checked={showWidget.AfterAppointment}
            onChange={(e) => setShowWidget(prev => ({ ...prev, AfterAppointment: e.target.checked }))}
            className="flex items-center text-sm font-bold text-slate-600 hover:text-slate-900"
          >
            Show Widget After Appointment Add/Edit
          </Checkbox>

          <div className="space-y-2 pt-2">
            <label className="text-sm font-bold text-slate-700 block">
              Schedule Time <span className="text-slate-400 font-medium">(Schedule Time in hour)</span>
            </label>
            <InputNumber 
              min={0}
              className="w-full rounded-xl border-slate-200 h-11 flex items-center shadow-sm"
              value={showWidget.ScheduleTime}
              onChange={(val) => setShowWidget(prev => ({ ...prev, ScheduleTime: val || 0 }))}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CallPreferenceModalV2;
